import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import Image from '../../../Core/Image';
import Container from '../../../Core/Container';
import Ctas from '../../../Core/Ctas';

export const StyledContainer = styled(Container)`
  margin: auto;
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--Number-6, 1.5rem);
  border-radius: 0.3125rem;
  padding: 2.75rem 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    gap: 2.5rem;
    padding: 2.75rem calc(11.5rem - 120px);
    flex-direction: row;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 1.5rem;
    text-align: ${({ $headingAlignment }) => $headingAlignment || 'left'};
  }

  h2 {
    font-size: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 2.25rem;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - 12.5rem);
    text-align: left;
  }
`;

export const Body = styled.div`
  p {
    font-size: 1rem;
    line-height: 150%;
  }
`;

export const Img = styled(Image)`
  width: 12.5rem;
  height: 12.5rem;
  margin: auto;
`;

export const StyledCtas = styled(Ctas)`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: start;
  }
`;
